<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed py-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-30"
    >
      <div
        class="mx-2 w-2/4 lg:w-1/4 max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto"
      >
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: "zip-name-modal",
  props: {
    showing: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }
};
</script>

<style scoped>
</style>